import React from 'react';

export function useStableCallback<_Function>(
    callback: (...args: any) => any
): (...args: any) => any {
    const callbackRef = React.useRef<(...args: any) => any>(callback);

    callbackRef.current = callback;

    return React.useCallback((...args) => {
        return callbackRef.current(...args);
    }, []);
}
